const Novel = (props) => {
  return (
    <div
      style={{
        width: '100vw',
        height: '100vh',
      }}
    >
      <div
        style={{
          width: '100vw',
          height: '100vh',
          maxWidth: '98vh',
          maxHeight: '105vw',
          backgroundSize: 'cover',
          whiteSpace: 'nowrap',
          textAlign: 'center',
          position: 'absolute',
          top: 0,
          bottom: 0,
          left: 0,
          right: 0,
          margin: 'auto',

        }}
      >
        <div
          style={{
            width: '100%',
            height: '79%',
            maxWidth: '100%',
            maxHeight: '100%',
            verticalAlign: 'middle',
            objectFit: 'contain',
            backgroundImage: `url(${process.env.PUBLIC_URL}/images/back_novel.png)`,
            backgroundSize: 'cover'
          }}
        >
        </div>
      </div >
    </div>
  );
};

export default Novel;
